import { TravelerReviewContent } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { UitkBadge } from "uitk-react-badge";
import { LocalizedComponentClass, withLocalization } from "bernie-l10n";
import { useLocalization } from "@shared-ui/localization-context";

interface GreatForAffinityBadgeProps {
  travelerReviewContent: TravelerReviewContent;
}

export const GreatForAffinityBadgeComponent = (props: GreatForAffinityBadgeProps) => {
  const { hotelsBadge } = props.travelerReviewContent;

  if (!hotelsBadge) {
    return null;
  }
  const { formatText } = useLocalization();

  const badgeText = formatText(hotelsBadge.text);

  return (
    <UitkBadge
      className="hotelBadge all-t-margin-three all-l-margin-three"
      icon={hotelsBadge.icon}
      text={badgeText}
      theme={hotelsBadge.theme}
    />
  );
};

export const GreatForAffinityBadge: LocalizedComponentClass<GreatForAffinityBadgeProps> = withLocalization(
  GreatForAffinityBadgeComponent
);
